import { render, staticRenderFns } from "./ModalIncluirDevedor.vue?vue&type=template&id=f0cbff64&scoped=true&"
import script from "./ModalIncluirDevedor.vue?vue&type=script&lang=js&"
export * from "./ModalIncluirDevedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cbff64",
  null
  
)

export default component.exports